import styled from 'styled-components';
import { Typography, Box, Divider } from '@mui/material';

export const ReviewContainer = styled(Box)`
  margin-top: 16px;
`;

export const SectionTitle = styled(Typography).attrs({
  variant: 'overline',
  color: 'primary',
})`
  font-size: 0.85rem;
  font-weight: bold;
  display: block;
  text-transform: none;
`;

export const FieldLabel = styled(Typography).attrs({
  variant: 'caption',
})`
  color: ${({ theme }) => theme.palette?.text?.secondary || '#666'};
  display: block;
  text-transform: none;
  letter-spacing: 0.5px;
`;

export const FieldValue = styled(Typography).attrs({
  variant: 'body1',
})`
  font-weight: 500;
  word-break: break-word;
`;

export const FooterBox = styled(Box)`
  padding: 16px;
  background-color: rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  margin-top: 32px;
`;

export const StyledDivider = styled(Divider)`
  margin-bottom: 16px;
  margin-top: 4px;
`;
